import { render, staticRenderFns } from "./PushNotificationDialog.vue?vue&type=template&id=a0b0ecf4&scoped=true&"
import script from "./PushNotificationDialog.vue?vue&type=script&lang=js&"
export * from "./PushNotificationDialog.vue?vue&type=script&lang=js&"
import style0 from "./PushNotificationDialog.vue?vue&type=style&index=0&id=a0b0ecf4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b0ecf4",
  null
  
)

export default component.exports